import { render } from "./RestaurantContractRate.vue?vue&type=template&id=a14a8c62&scoped=true"
import script from "./RestaurantContractRate.vue?vue&type=script&lang=js"
export * from "./RestaurantContractRate.vue?vue&type=script&lang=js"

import "./RestaurantContractRate.vue?vue&type=style&index=0&id=a14a8c62&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a14a8c62"

export default script